"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isObject(obj) {
    // Note: typeof undefined === 'undefined'
    return obj !== null && typeof obj === 'object';
}
exports.isObject = isObject;
// After component has static method getInitialProps().
function isAfterComponent(Component) {
    return Component.getInitialProps !== undefined;
}
exports.isAfterComponent = isAfterComponent;
// A loadable component can be loaded via static method load().
function isLoadableComponent(Component) {
    return Component.load !== undefined;
}
exports.isLoadableComponent = isLoadableComponent;
//# sourceMappingURL=index.js.map